import { useEffect, useState } from 'react';
import { HelpRequestApi } from 'services';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { toastMessages } from 'config/constants';
import { format } from 'date-fns';
import { toCamelCase } from 'utils';
import { reduce } from 'lodash';
import toast from 'react-hot-toast';
import useStyles from './styles';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function IncidentTracking() {
  const classes = useStyles();
  const [helpRequests, setHelpRequests] = useState([]);
  const [openedRequest, setOpenedRequest] = useState([]);
  const [closedRequest, setClosedRequest] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    getHelpRequests();
  }, []);

  async function getHelpRequests() {
    setIsFetching(true);
    try {
      const { data: helpRequests } = await HelpRequestApi.getHelpRequests();
      const tickets = helpRequests.map(toCamelCase);

      const { opened, closed } = reduce(
        tickets,
        (acc, ticket) => {
          acc[ticket.state].push({
            ...ticket,
            creationDate: new Date(ticket.creationDate),
          });
          return acc;
        },
        { opened: [], closed: [] },
      );

      setHelpRequests(opened);
      setOpenedRequest(opened);
      setClosedRequest(closed);
    } catch (_) {
      toast.error(toastMessages.error.FETCH_HELP_REQUESTS);
    }
    setIsFetching(false);
  }

  return (
    <Grid
      item
      container
      xs
      direction="column"
      alignItems="center"
      justifyContent="center"
      className="HelpRequests"
    >
      <Typography variant="h3" style={{ paddingTop: '5vh' }}>
        Suivi Incidents
      </Typography>
      <Grid
        className={classes.ticketContent}
        style={{ paddingBottom: '5vh', paddingTop: '5vh', width: '100%' }}
      >
        <span
          onClick={() => {
            setHelpRequests(openedRequest);
          }}
          style={{ color: '#4459C6', cursor: 'pointer' }}
        >
          Demandes en cours
        </span>
        <span
          onClick={() => {
            setHelpRequests(closedRequest);
          }}
          style={{ textDecorationLine: 'underline', cursor: 'pointer' }}
        >
          Demandes passées
        </span>
      </Grid>
      {isFetching && (
        <Grid container alignItems="center" justifyContent="center" style={{ height: '52vh' }}>
          <CircularProgress />
        </Grid>
      )}
      <Grid container direction="column">
        {!isFetching &&
          helpRequests.map((ticket) => {
            return (
              <Grid key={ticket.id} justifyContent="center" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '1vw 1vw 0 0',
                    alignItems: 'center',
                  }}
                >
                  <Typography className={classes.dateTitle}>
                    {ticket.creationDate.getDate()}
                  </Typography>
                  <Typography className={classes.dateTitle}>
                    {months[ticket.creationDate.getMonth()]}
                  </Typography>
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    height: '14vh',
                    border: '1px solid grey',
                    color: '#828282',
                    marginBottom: '3vh',
                    borderRadius: '10px',
                  }}
                >
                  <div>
                    <div
                      className={classes.ticketContent}
                      style={{ borderBottom: '1px solid grey', height: '6vh' }}
                    >
                      <span>N° dossier #{ticket.id}</span>
                      <span style={{ fontSize: '0.7vw' }}>
                        {format(ticket.creationDate, 'dd/MM/yy')}
                      </span>
                    </div>
                    <div className={classes.ticketContent} style={{ height: '8vh' }}>
                      <span>{ticket.subject}</span>
                      <span style={{ fontSize: '0.7vw' }}>{ticket.state}</span>
                    </div>
                  </div>
                </div>
              </Grid>
            );
          })}
      </Grid>
    </Grid>
  );
}
